export interface FormErrorProps {
  message?: string | null
  className?: string
}

export const FormError = ({ message, className }: FormErrorProps) => {
  if (!message) return null

  return <div className="error">{message}</div>
}
